var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"createorder",staticClass:"createorder"},[_c('el-form',{ref:"createorderform",style:({ height: `${_vm.windowHeight}px`, 'overflow-y': 'auto' })},[_c('rate',{ref:"rate",on:{"formScrollTop":_vm.formScrollTop,"cancel":_vm.cancel}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }